<img
  class="principle-logo"
  src="/assets/icons/principle-row-white.svg"
  onerror="this.src='/assets/icons/principle-row-white.png'"
/>
